export async function loadGoogleMaps(): Promise<typeof google.maps> {
  return new Promise((resolve, reject) => {
    (function waitForGoogleMaps(retries = 0) {
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      if (window.google && window.google.maps) {
        resolve(window.google.maps);
        return;
      }

      // @ts-expect-error TS(2339): Property 'MAPS_API_ERROR' does not exist on type '... Remove this comment to see the full error message
      if (window.MAPS_API_ERROR) {
        // @ts-expect-error TS(2339): Property 'MAPS_API_ERROR' does not exist on type '... Remove this comment to see the full error message
        reject(new Error(window.MAPS_API_ERROR));
      }

      // retry for 10s
      if (retries > 100) {
        reject(new Error('TIMEOUT'));
      }

      setTimeout(waitForGoogleMaps, 100, retries + 1);
    })();
  });
}
